module.exports = __webpack_public_path__ + "img/top_banner4.07849365.png";